import React from 'react';

const Logo = ({ variant = 'horizontal', size = 'medium', className = '' }) => {
  const sizes = {
    small: { width: '180', height: '50', fontSize: '16', pathStroke: '2' },
    medium: { width: '240', height: '65', fontSize: '20', pathStroke: '2.5' },
    large: { width: '583', height: '182', fontSize: '51', pathStroke: '5' }
  };

  const currentSize = sizes[size];

  if (variant === 'icon-only') {
    return (
      <div className={`inline-block ${className}`}>
        <svg 
          width="40" 
          height="40" 
          viewBox="0 0 40 40" 
          className="drop-shadow-sm"
        >
          <defs>
            <linearGradient id="iconGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{stopColor:'#FF6B9D', stopOpacity:1}} />
              <stop offset="100%" style={{stopColor:'#8B5CF6', stopOpacity:1}} />
            </linearGradient>
          </defs>
          <rect width="40" height="40" fill="url(#iconGradient)" rx="8"/>
          <path 
            d="M8 20 Q14 12, 20 20 T28 16 T36 22" 
            stroke="white" 
            strokeWidth="2.5" 
            fill="none" 
            strokeLinecap="round"
            opacity="0.95"
          />
          <circle cx="12" cy="18" r="1" fill="white" opacity="0.8"/>
          <circle cx="24" cy="18" r="1" fill="white" opacity="0.8"/>
          <circle cx="32" cy="21" r="1" fill="white" opacity="0.8"/>
        </svg>
      </div>
    );
  }

  return (
    <div className={`inline-block ${className}`}>
      <svg 
        width={currentSize.width} 
        height={currentSize.height} 
        viewBox={`0 0 ${currentSize.width} ${currentSize.height}`}
        className="drop-shadow-sm"
      >
        <defs>
          <linearGradient id="pathGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style={{stopColor:'#FF6B9D', stopOpacity:1}} />
            <stop offset="50%" style={{stopColor:'#C77DFF', stopOpacity:1}} />
            <stop offset="100%" style={{stopColor:'#8B5CF6', stopOpacity:1}} />
          </linearGradient>
          
          {/* Glow filter for the moving point */}
          <filter id="glow">
            <feGaussianBlur stdDeviation="4" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>
        
        {/* Winding Path Icon - extends further across */}
        <g transform={`translate(${currentSize.width * 0.05}, ${currentSize.height * 0.25})`}>
          <path 
            id="motionPath"
            d={`M10 ${currentSize.height * 0.25} Q20 ${currentSize.height * 0.15}, 30 ${currentSize.height * 0.25} T50 ${currentSize.height * 0.2} T70 ${currentSize.height * 0.3} T90 ${currentSize.height * 0.25} T110 ${currentSize.height * 0.2} T130 ${currentSize.height * 0.28} T150 ${currentSize.height * 0.25} T170 ${currentSize.height * 0.22}`}
            stroke="url(#pathGradient)" 
            strokeWidth={currentSize.pathStroke} 
            fill="none" 
            strokeLinecap="round"
          />
          
          {/* Waypoint markers */}
          <circle cx="15" cy={currentSize.height * 0.23} r="2" fill="#FF6B9D"/>
          <circle cx="40" cy={currentSize.height * 0.22} r="2" fill="#C77DFF"/>
          <circle cx="65" cy={currentSize.height * 0.27} r="2" fill="#9F7AEA"/>
          <circle cx="85" cy={currentSize.height * 0.25} r="2" fill="#8B5CF6"/>
          <circle cx="105" cy={currentSize.height * 0.2} r="2" fill="#9F7AEA"/>
          <circle cx="125" cy={currentSize.height * 0.27} r="2" fill="#C77DFF"/>
          <circle cx="145" cy={currentSize.height * 0.25} r="2" fill="#FF6B9D"/>
          <circle cx="165" cy={currentSize.height * 0.22} r="2" fill="#8B5CF6"/>
          
          {/* Animated glowing point */}
          <circle r="6" fill="#FFFFFF" filter="url(#glow)" opacity="0.6">
            <animateMotion 
              dur="6.4s" 
              repeatCount="indefinite"
              begin="0s;motionAnim.end+3s"
            >
              <mpath href="#motionPath" />
            </animateMotion>
            <animate 
              attributeName="opacity"
              values="0;0;0.4;0.6;0.6;0.4;0"
              dur="6.4s"
              repeatCount="indefinite"
              begin="0s;motionAnim.end+3s"
            />
            <animate 
              attributeName="r"
              values="4;6;8;6;4"
              dur="6.4s"
              repeatCount="indefinite"
              begin="0s;motionAnim.end+3s"
            />
          </circle>
          
          {/* Inner bright core of the glowing point */}
          <circle r="3" fill="#FFE5F1" opacity="0.8">
            <animateMotion 
              dur="6.4s" 
              repeatCount="indefinite"
              begin="0s;motionAnim.end+3s"
              id="motionAnim"
            >
              <mpath href="#motionPath" />
            </animateMotion>
            <animate 
              attributeName="opacity"
              values="0;0;0.5;0.8;0.8;0.5;0"
              dur="6.4s"
              repeatCount="indefinite"
              begin="0s;motionAnim.end+3s"
            />
          </circle>
        </g>
        
        {/* Typography */}
        <text 
          x={currentSize.width / 2} 
          y={currentSize.height * 0.72} 
          fontFamily="'Segoe UI', Arial, sans-serif" 
          fontSize={currentSize.fontSize} 
          fontWeight="600" 
          fill="white" 
          textAnchor="middle"
        >
          gamimap
        </text>
      </svg>
    </div>
  );
};

export default Logo;